import Taxes from './Taxes';

export default Taxes;
